import { OPERATION_TYPE } from "../../../../../../util/varibles/constants";
import { IPropsSearchItem } from "../constants";
import Event from "./Event";
import Harvest from "./Harvest";
import Service from "./Service";
import Support from "./Support";
import Transport from "./Transport";
import Treatment from "./Treatment";

interface IProps extends IPropsSearchItem {
}

const Operation: React.FC<IProps> = (props) => {
    const { operation_type } = props.data;
    switch (operation_type) {
        case OPERATION_TYPE.HARVEST:
            return <Harvest {...props} />
        case OPERATION_TYPE.TREATMENT:
            return <Treatment {...props} />
        case OPERATION_TYPE.EVENT:
            return <Event {...props} />
        case OPERATION_TYPE.TRANSPORT:
            return <Transport {...props} />
        case OPERATION_TYPE.SERVICE:
            return <Service {...props} />
        case OPERATION_TYPE.SUPPORT:
            return <Support {...props} />
        default:
            return null;
    }
}

export default Operation;
